/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var QuerySortOrderEnum;

(function (QuerySortOrderEnum) {
  QuerySortOrderEnum["ASC"] = "ASC";
  QuerySortOrderEnum["DESC"] = "DESC";
})(QuerySortOrderEnum || (QuerySortOrderEnum = {}));